import { JSX } from 'react';

import { Badge } from '@videoblocks/design-system';

import { FeatureIcon } from '../FeatureIcon';

type Feature = {
    name: string;
    isAvailable: boolean;
};

type UpgradeCreditPlanCardDetailsProps = {
    licenseType: string;
    AIToolkit: Feature[];
    mediaTypes: Feature[];
    workflowTools: Feature[];
    downloads?: Feature[];
};

export default function UpgradeCreditPlanCardDetails({
    licenseType,
    AIToolkit,
    downloads,
    mediaTypes,
    workflowTools,
}: UpgradeCreditPlanCardDetailsProps): JSX.Element {
    return (
        <div className="space-y-5 text-sm text-gray-700">
            <div>
                <div className="">
                    <h4 className="text-gray-800 font-semibold mb-1">1 user</h4>
                    <h4 className="text-gray-800 font-semibold mb-1">{licenseType}</h4>
                </div>
            </div>

            {/* Media types */}
            {mediaTypes.length > 0 && (
                <div>
                    <h4 className="font-semibold mb-1 text-gray-900">Unlimited downloads</h4>
                    <ul className="space-y-1">
                        {mediaTypes
                            .filter((item) => item.isAvailable)
                            .map((item) => (
                                <li key={item.name} className="flex items-center gap-2">
                                    <FeatureIcon isAvailable={item.isAvailable} />
                                    <span className="text-gray-900">{item.name}</span>
                                </li>
                            ))}
                    </ul>
                </div>
            )}

            {/* AI Toolkit */}
            {mediaTypes.length > 0 && (
                <div>
                    <h4 className="font-semibold mb-1 text-gray-900">
                        AI Toolkit
                        <Badge
                            size="small"
                            text={'New'}
                            fontWeight="semibold"
                            className="font-polysans inline-block ml-1 relative -top-[2px] bg-blue-900 text-white"
                        />
                    </h4>
                    <ul className="space-y-1">
                        {AIToolkit.filter((item) => item.isAvailable).map((item) => (
                            <li key={item.name} className="flex items-center gap-2">
                                <FeatureIcon isAvailable={item.isAvailable} />
                                <span className="text-gray-900">{item.name}</span>
                            </li>
                        ))}
                    </ul>
                </div>
            )}

            {/* Workflow tools */}
            {workflowTools.length > 0 && (
                <div>
                    <h4 className="font-semibold mb-1 text-gray-900">Workflow tools</h4>
                    <ul className="space-y-1">
                        {workflowTools
                            .filter((item) => item.isAvailable)
                            .map((item) => (
                                <li key={item.name} className="flex items-center gap-2">
                                    <FeatureIcon isAvailable={item.isAvailable} />
                                    <span className="text-gray-900">{item.name}</span>
                                </li>
                            ))}
                    </ul>
                </div>
            )}
        </div>
    );
}
